import axios from "axios";
import { useSchoolStore } from "../store/SchoolStore";

export const addSchool = async ({name, description, motto, cityId, stateId, countryId, administratorId, ownerId, foundYear, phoneNumber, email, website, schoolTypeId, createdBy, categories }) => {

  try {

    const { data } = await axios.post("/api/v1/school", { name, description, motto, cityId, stateId, countryId, administratorId, ownerId, foundYear, phoneNumber, email, website, schoolTypeId, createdBy, categories });

    return data;

  } catch (error) {
    throw error;
  }
};


export const editSchool = async ({id, name, description, motto, cityId, stateId, countryId, foundYear, phoneNumber, email, website, schoolTypeId, modifiedBy, categories }) => {

  try {

    const { data } = await axios.patch("/api/v1/school", {id, name, description, motto, cityId, stateId, countryId, foundYear, phoneNumber, email, website, schoolTypeId, modifiedBy, categories });

    return data;

  } catch (error) {
    throw error;
  }
};

export const getSchoolsByOwner = async (id) => {
  try {
    const { data } = await axios.get(`/api/v1/school/owner?id=${id}`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const getSchoolsByUser = async (id) => {
  try {
    const { data } = await axios.get(`/api/v1/school/user?id=${id}`);
    return data;
  } catch (error) {
    throw error;
  }
};


export const getSchools = async (pageNumber = 1, pageSize = 1000) => {
  try {
  } catch (error) {
    throw error;
  }
};

export const getSchool = async (schoolId) => {
  try {
    const { data } = await axios.get(`/api/v1/school?id=${schoolId}`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const getSchoolViewHeaderData = async (SchoolId, yearId) => {
  try {
    const { data } = await axios.get(
      `/api/Companies?SchoolId=${SchoolId}&financialYearId=${yearId}`
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const deleteSchool = async (id) => {
  try {
    return await axios.delete(`/api/v1/school?id=${id}`);
  } catch (error) {
    throw error;
  }
};
